import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Stack } from "@volca/ui/components/ui/stack";
import {
  PublicDocumentCard,
  type PublicPdfState,
} from "./public-document-card";
import { type PublicDocumentKind, usePublicPdfStatus } from "./query";

const PublicDocumentPage = ({ kind }: { kind: PublicDocumentKind }) => {
  const { documentId = "" } = useParams<{ documentId: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    data: pdfUrl,
    isPending,
    isError,
  } = usePublicPdfStatus(kind, documentId);

  let pdf: PublicPdfState;
  if (isPending) pdf = { status: "loading" };
  else if (isError) pdf = { status: "error" };
  else if (pdfUrl) pdf = { status: "available", pdfUrl };
  else pdf = { status: "unavailable" };

  return (
    <Stack
      direction="row"
      align="center"
      justify="center"
      className="min-h-page w-full p-6"
    >
      <PublicDocumentCard
        kind={kind}
        pdf={pdf}
        onSignIn={() => navigate("/login", { state: { from: location } })}
      />
    </Stack>
  );
};

export default PublicDocumentPage;
